<template>
    <pre class="error-stack" v-html="`${error.message} ${error.stack}`" />
</template>

<script setup lang="ts">
    defineProps<{
        error: Error;
    }>();
</script>

<style scoped lang="scss">
    .error-stack {
        background-color: var(--joy-color-neutral-50);
        width: 100%;
        color: var(--joy-color-neutral-0);
        overflow-x: auto;
        border-radius: var(--joy-core-radius-3);
        padding: var(--joy-core-spacing-4);
        text-align: left;
        white-space: pre-wrap;
    }
</style>
